import { render, staticRenderFns } from "./BeCardEmployee.vue?vue&type=template&id=7f4f1175&scoped=true"
import script from "./BeCardEmployee.vue?vue&type=script&lang=js"
export * from "./BeCardEmployee.vue?vue&type=script&lang=js"
import style0 from "./BeCardEmployee.vue?vue&type=style&index=0&id=7f4f1175&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f1175",
  null
  
)

export default component.exports